<template>
  <div>
    <Modal :title="title" v-model="modalShow" width="600px">
      <Spin fix v-if="dataGetting"></Spin>
      <Alert show-icon type="error" v-else-if="getDataError">获取数据失败</Alert>
      <div class="req-form" v-else>
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="云硬盘" prop="volumeId">
            <Select v-model="reqForm.volumeId" transfer placeholder="请选择要挂载的云硬盘">
              <Option v-for="item in volumeList" :key="item.id" :value="item.id">{{ item.name }} ({{ item.id }})</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting" :disabled="getDataError">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { volumeAttachmentPrivateCloudServer } from '@/api/private-cloud/server'
import { getPrivateCloudAllVolume } from '@/api/private-cloud/volume'
export default {
  name: 'server-attach-volume',
  data () {
    return {
      title: '挂载云硬盘',
      serverId: '',
      dataGetting: false,
      getDataError: false,
      modalShow: false,
      submitting: false,
      volumeList: [],
      reqForm: {
        volumeId: ''
      },
      reqRule: {
        volumeId: [
          { required: true, message: '请选择要挂载的云硬盘', trigger: 'change' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id) {
      this.serverId = id
      this.modalShow = true
      this.getVolumeList()
      this.reqForm.volumeId = ''
    },
    // 获取云硬盘列表
    getVolumeList () {
      this.dataGetting = true
      getPrivateCloudAllVolume({status: 'available'}).then(res => {
        this.volumeList = res.data
        this.dataGetting = false
        this.getDataError = false
      }).catch(res => {
        this.dataGetting = false
        this.getDataError = true
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'volumeAttachment': this.reqForm
          }
          this.submitting = true
          volumeAttachmentPrivateCloudServer(reqData, this.serverId).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
